export enum VesselVisitDocumentTypeCodes {
    FAL1A = 'FAL1A',
    FAL1D = 'FAL1D',
    FAL2A = 'FAL2A',
    FAL2D = 'FAL2D',
    FAL3A = 'FAL3A',
    FAL3D = 'FAL3D',
    FAL4A = 'FAL4A',
    FAL4D = 'FAL4D',
    FAL5A = 'FAL5A',
    FAL5D = 'FAL5D',
    FAL6A = 'FAL6A',
    FAL6D = 'FAL6D',
    FAL7A = 'FAL7A',
    FAL7D = 'FAL7D',
    ISPS = 'ISPS',
    OTHER = 'OTHER',
    WASTE = 'WASTE',
    CUSTPER = 'CUSTPER',
    AGVP = 'AGVP',
    CM = 'CM',
    CP = 'CP',
    NOTR = 'NOTR',
    CRT = 'CRT',
    SUM = 'SUM',
    AP = 'AP',
    AR = 'AR',
    OP = 'OP'
}